import { isApiFormError, isFieldErrorResponse, useApiAccountsV1SigninRequestCreate } from 'api';
import { SignInPage, SignInPhoneForm, useNotification } from 'features';
import { safiLogo } from 'features/brand';
import { Trans, useTranslation } from 'i18n';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import { Link, Typography } from 'ui';

import { getAuthRoute } from '../../utils/getAuthRoute';
import { isSafiApp } from '../../utils/isSafiApp';

export const SignInPhone = () => {
  const { t } = useTranslation('auth');
  const { t: tCommon } = useTranslation('common');
  const navigate = useNavigate();
  const { open } = useNotification();

  const { mutate, isPending } = useApiAccountsV1SigninRequestCreate({
    mutation: {
      onError(error) {
        if (isApiFormError(error)) {
          open({
            description: error?.response?.data.detail,
            message: t('notifications.errorSigningIn'),
            type: 'error',
          });
          return;
        }
        if (isFieldErrorResponse(error)) {
          open({
            description: error?.response?.data.non_field_errors?.[0],
            message: t('notifications.errorSigningIn'),
            type: 'error',
          });
          return;
        }

        open({
          message: t('notifications.errorSigningIn'),
          type: 'error',
        });
      },
      onSuccess() {
        navigate(getAuthRoute('/sign-in/phone/verify'));
      },
    },
  });

  return (
    <SignInPage logo={safiLogo}>
      <SignInPhoneForm
        emailSignInRoute={getAuthRoute('/sign-in/email')}
        onSubmit={(data) => mutate({ data })}
        isLoading={isPending}
      />
      {!isSafiApp() && (
        <Typography variant="body2">
          <Trans
            namespace="auth"
            i18nKey="signIn.newToSafi"
            values={{ brandName: tCommon('brand.name') }}
            components={{
              createAccountLink: <Link component={RouterLink} to={getAuthRoute('/sign-up')} />,
            }}
          />
        </Typography>
      )}
    </SignInPage>
  );
};
